import { render, staticRenderFns } from "./dispensation3.vue?vue&type=template&id=441ceef3&scoped=true"
import script from "./dispensation3.vue?vue&type=script&lang=js"
export * from "./dispensation3.vue?vue&type=script&lang=js"
import style0 from "./dispensation3.vue?vue&type=style&index=0&id=441ceef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441ceef3",
  null
  
)

export default component.exports